import { Status } from './connector';
import { TitleCasePipe } from '@angular/common';

export class ProjectStatusInfo {
    status: Status;
    label: string;
    name: string;

    private iconClass: string;
    private iconColor: string;

    constructor(value?: Partial<ProjectStatusInfo>) {
        if (value) {
            Object.assign(this, value);
            this.label = new TitleCasePipe().transform(this.status);

            switch (this.status) {
                case Status.WARNING:
                    this.iconClass = 'fa-exclamation-triangle';
                    this.iconColor = 'color-yellow-07';
                    break;
                case Status.FAILURE:
                    this.iconClass = 'fa-exclamation-circle';
                    this.iconColor = 'color-red-05';
                    this.label = 'Critical';
                    break;
                case Status.AVAILABLE:
                    this.iconClass = ' fa-check';
                    this.iconColor = 'color-green-04';
                    break;
            }
        }
    }
}
